module.exports = __webpack_public_path__ + "static/media/chat.afe561a9.svg";